import React from 'react';
import { ArrowRight } from 'lucide-react';
const Logo = () => <img src="https://cdn.magicpatterns.com/uploads/635dXvyehukv1voVp8uDzR/Union_(6).png" alt="Proximitty" className="h-7 w-auto" data-id="element-0" />;
export function App() {
  return <div className="min-h-screen py-12 flex justify-center items-start font-['Open_Sans',_sans-serif] text-slate-800 bg-[#F7F4F0]" data-id="element-1">
      {/* A4 Paper Container */}
      <div className="w-[816px] min-h-[1056px] bg-[#F7FAFD] shadow-2xl flex flex-col relative" data-id="element-2">
        {/* HEADER */}
        <header className="px-10 py-5 flex justify-between items-center bg-[#F8F7F6]" data-id="element-3">
          <Logo data-id="element-4" />
          <div className="text-right" data-id="element-5">
            <div className="font-medium text-sm font-['Tiro_Gurmukhi',_serif] text-[#0282C7]" data-id="element-6">
              AI agents for business loan servicing
            </div>
            <div className="text-xs mt-0.5 font-['Tiro_Gurmukhi',_serif] text-[#0C0C0C]" data-id="element-7">
              Compliance and reliable first by design
            </div>
          </div>
        </header>

        {/* HERO SECTION */}
        <section className="px-10 py-6 bg-[#F8F7F6]" data-id="element-8">
          <h1 className="text-[26px] leading-[1.15] text-slate-900 mb-8 max-w-[95%] font-[500] font-['Tiro_Gurmukhi',_serif]" data-id="element-9">
            Enterprise-grade AI agents that engage borrowers pre-delinquency and
            collect — no engineering work required.
          </h1>
          <p className="max-w-[95%] font-[400] text-[#0F0E0E] font-['Tiro_Gurmukhi',_serif] text-[14px]" data-id="element-10">
            Proximitty's no-code agent studio deploys voice, SMS, email, and
            browser agents across your entire portfolio — intervening before
            delinquency, automating repayment negotiation, and enforcing
            compliance in real time. Built for banks, credit unions, private
            credit funds and fintechs that do business lending.
          </p>
        </section>

        {/* MOCK UI SECTION */}
        <section className="px-8 py-3 bg-[#F8F7F6]" data-id="element-11">
          <div className="border border-slate-200 rounded-lg overflow-hidden shadow-sm bg-white flex flex-col" data-id="element-12">
            {/* Mock UI Header */}
            <div className="bg-white border-b border-slate-200 px-3 py-1.5 flex items-center text-xs text-slate-500" data-id="element-13">
              <div className="flex items-center gap-1" data-id="element-14">
                <div className="w-2 h-2 rounded-full bg-red-400" data-id="element-15"></div>
                <div className="w-2 h-2 rounded-full bg-amber-400" data-id="element-16"></div>
                <div className="w-2 h-2 rounded-full bg-green-400" data-id="element-17"></div>
              </div>
            </div>

            <div className="flex flex-1" data-id="element-18">
              {/* Mock UI Sidebar */}
              <div className="w-28 border-r border-slate-200 bg-white py-1 flex flex-col" data-id="element-19">
                <div className="px-3 py-1.5 flex items-center gap-1.5 mb-1" data-id="element-20">
                  <div className="w-2 h-2 rotate-45 bg-blue-400 relative" data-id="element-21">
                    <div className="absolute inset-0.5 bg-white" data-id="element-22"></div>
                    <div className="absolute inset-[3px] bg-blue-400" data-id="element-23"></div>
                  </div>
                  <span className="font-bold text-slate-800 text-[10px]" data-id="element-24">
                    Proximitty
                  </span>
                </div>
                <div className="flex flex-col px-1.5" data-id="element-25">
                  <div className="px-2 py-0.5 text-slate-500 text-[9px] flex items-center gap-1.5 rounded" data-id="element-26">
                    <div className="w-1 h-1 rounded-full bg-slate-300" data-id="element-27"></div>
                    Platform
                  </div>
                  <div className="px-2 py-0.5 bg-[#EAF5FF] text-[#0284C7] text-[9px] font-medium flex items-center gap-1.5 rounded relative overflow-hidden" data-id="element-28">
                    <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-[#0284C7]" data-id="element-29"></div>
                    <div className="w-1 h-1 rounded-full bg-[#0284C7]" data-id="element-30"></div>
                    Collections
                  </div>
                  <div className="px-2 py-0.5 text-slate-500 text-[9px] flex items-center gap-1.5 rounded" data-id="element-31">
                    <div className="w-1 h-1 rounded-full bg-slate-300" data-id="element-32"></div>
                    Servicing
                  </div>
                  <div className="px-2 py-0.5 text-slate-500 text-[9px] flex items-center gap-1.5 rounded" data-id="element-33">
                    <div className="w-1 h-1 rounded-full bg-slate-300" data-id="element-34"></div>
                    Agent Studio
                  </div>
                  <div className="px-2 py-0.5 text-slate-500 text-[9px] flex items-center gap-1.5 rounded" data-id="element-35">
                    <div className="w-1 h-1 rounded-full bg-slate-300" data-id="element-36"></div>
                    Calls
                  </div>
                  <div className="px-2 py-0.5 text-slate-500 text-[9px] flex items-center gap-1.5 rounded" data-id="element-37">
                    <div className="w-1 h-1 rounded-full bg-emerald-400" data-id="element-38"></div>
                    Compliance
                  </div>
                </div>
              </div>

              {/* Mock UI Main Content */}
              <div className="flex-1 flex flex-col p-3 bg-white" data-id="element-39">
                {/* Top Bar */}
                <div className="flex justify-between items-center mb-2" data-id="element-40">
                  <div className="flex items-center gap-2" data-id="element-41">
                    <h2 className="text-[11px] font-bold text-slate-800" data-id="element-42">
                      Cedar & Pine Design Studio
                    </h2>
                    <span className="bg-red-50 text-red-500 text-[8px] font-bold px-1.5 py-0.5 rounded" data-id="element-43">
                      Delinquent: $45,800
                    </span>
                  </div>
                  <div className="text-[8px] text-slate-400" data-id="element-44">
                    Last login: Feb 7, 2026 · 9:42 AM
                  </div>
                </div>

                {/* AI Recommended Action */}
                <div className="border border-blue-100 bg-[#F4F9FF] rounded px-2.5 py-1.5 mb-2 flex justify-between items-center" data-id="element-45">
                  <div data-id="element-46">
                    <div className="flex items-center gap-1 text-blue-500 text-[8px] font-bold tracking-wider uppercase mb-0.5" data-id="element-47">
                      <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-48">
                        <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" data-id="element-49" />
                      </svg>
                      AI RECOMMENDED ACTION
                    </div>
                    <p className="text-[9px] text-slate-700 font-medium leading-snug" data-id="element-50">
                      Initiate AI outbound call using newly verified owner
                      number — wire confirmed across Gmail & bank portal
                    </p>
                  </div>
                  <button className="bg-white border border-slate-100 text-slate-400 px-2 py-0.5 rounded text-[8px] font-bold flex items-center gap-1 shadow-sm shrink-0 ml-3" data-id="element-51">
                    Review
                    <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-52">
                      <path d="M5 12h14" data-id="element-53" />
                      <path d="m12 5 7 7-7 7" data-id="element-54" />
                    </svg>
                  </button>
                </div>

                {/* Two Columns */}
                <div className="flex gap-3" data-id="element-55">
                  {/* Left Column */}
                  <div className="flex-1 flex flex-col gap-2" data-id="element-56">
                    {/* ABILITY TO PAY */}
                    <div data-id="element-57">
                      <div className="text-[8px] font-bold text-slate-400 tracking-wider mb-1.5 flex items-center gap-1 uppercase" data-id="element-58">
                        <div className="w-0.5 h-2 bg-blue-400" data-id="element-59"></div>
                        Ability to Pay Assessment
                      </div>
                      <div className="flex items-center gap-4" data-id="element-60">
                        <div className="relative w-10 h-10" data-id="element-61">
                          <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90" data-id="element-62">
                            <circle cx="18" cy="18" r="16" fill="none" className="stroke-slate-100" strokeWidth="4" data-id="element-63" />
                            <circle cx="18" cy="18" r="16" fill="none" className="stroke-amber-500" strokeWidth="4" strokeDasharray="62, 100" data-id="element-64" />
                          </svg>
                          <div className="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-slate-800" data-id="element-65">
                            62%
                          </div>
                        </div>
                        <div className="flex gap-3" data-id="element-66">
                          <div className="flex flex-col items-center" data-id="element-67">
                            <span className="text-sm font-bold text-slate-800 leading-none" data-id="element-68">
                              48
                            </span>
                            <span className="text-[8px] text-slate-500" data-id="element-69">
                              Willingness
                            </span>
                            <span className="text-[7px] font-bold text-amber-600 bg-amber-50 px-1 py-0.5 rounded" data-id="element-70">
                              Low-Mod
                            </span>
                          </div>
                          <div className="flex flex-col items-center" data-id="element-71">
                            <span className="text-sm font-bold text-slate-800 leading-none" data-id="element-72">
                              71
                            </span>
                            <span className="text-[8px] text-slate-500" data-id="element-73">
                              Capacity
                            </span>
                            <span className="text-[7px] font-bold text-emerald-600 bg-emerald-50 px-1 py-0.5 rounded" data-id="element-74">
                              Moderate
                            </span>
                          </div>
                          <div className="flex flex-col items-center" data-id="element-75">
                            <span className="text-sm font-bold text-slate-800 leading-none" data-id="element-76">
                              67
                            </span>
                            <span className="text-[8px] text-slate-500" data-id="element-77">
                              Stability
                            </span>
                            <span className="text-[7px] font-bold text-emerald-600 bg-emerald-50 px-1 py-0.5 rounded" data-id="element-78">
                              Moderate
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* DEBTOR INTELLIGENCE */}
                    <div data-id="element-79">
                      <div className="text-[8px] font-bold text-slate-400 tracking-wider mb-1 flex items-center gap-1 uppercase" data-id="element-80">
                        <div className="w-0.5 h-2 bg-blue-400" data-id="element-81"></div>
                        Debtor Intelligence Brief
                      </div>
                      <div className="grid grid-cols-2 gap-1.5" data-id="element-82">
                        <div className="border border-purple-100 bg-[#F9F8FC] rounded p-1.5 border-l-2 border-l-purple-400" data-id="element-83">
                          <div className="text-[7px] font-bold text-purple-500 tracking-wider uppercase mb-0.5" data-id="element-84">
                            Entity Profile
                          </div>
                          <div className="text-[9px] text-slate-600 leading-snug" data-id="element-85">
                            <strong className="text-slate-800" data-id="element-86">
                              6-yr boutique design firm
                            </strong>
                            , 8–12 emp. FICO{' '}
                            <strong className="text-slate-800" data-id="element-87">720+</strong>, no
                            prior collections.
                          </div>
                        </div>
                        <div className="border border-blue-100 bg-[#F4F9FF] rounded p-1.5 border-l-2 border-l-blue-400" data-id="element-88">
                          <div className="text-[7px] font-bold text-blue-500 tracking-wider uppercase mb-0.5" data-id="element-89">
                            Financial Signals
                          </div>
                          <div className="text-[9px] text-slate-600 leading-snug" data-id="element-90">
                            Cash flow{' '}
                            <strong className="text-slate-800" data-id="element-91">
                              down 15% YoY
                            </strong>
                            . Lease dispute Dec 2025. W/C & Spend delinquent.
                          </div>
                        </div>
                        <div className="border border-amber-100 bg-[#FFFBF4] rounded p-1.5 border-l-2 border-l-amber-400" data-id="element-92">
                          <div className="text-[7px] font-bold text-amber-500 tracking-wider uppercase mb-0.5" data-id="element-93">
                            Behavioral Pattern
                          </div>
                          <div className="text-[9px] text-slate-600 leading-snug" data-id="element-94">
                            <strong className="text-slate-800" data-id="element-95">
                              3 PTPs in 90 days
                            </strong>
                            , honored 1. Callback 1d → 5+d. 60–70% settlement.
                          </div>
                        </div>
                        <div className="border border-emerald-100 bg-[#F4FCF7] rounded p-1.5 border-l-2 border-l-emerald-400" data-id="element-96">
                          <div className="text-[7px] font-bold text-emerald-500 tracking-wider uppercase mb-0.5" data-id="element-97">
                            Recommended Path
                          </div>
                          <div className="text-[9px] text-slate-600 leading-snug" data-id="element-98">
                            <strong className="text-slate-800" data-id="element-99">
                              3 installments
                            </strong>{' '}
                            + wire verify. Partial Settlement:{' '}
                            <strong className="text-slate-800" data-id="element-100">High</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - ACTIVITY */}
                  <div className="w-44" data-id="element-101">
                    <div className="text-[8px] font-bold text-slate-400 tracking-wider mb-1.5 flex items-center gap-1 uppercase" data-id="element-102">
                      <div className="w-0.5 h-2 bg-blue-400" data-id="element-103"></div>
                      Activity
                    </div>
                    <div className="relative border-l border-slate-100 ml-2 flex flex-col gap-2.5" data-id="element-104">
                      <div className="relative pl-4" data-id="element-105">
                        <div className="absolute -left-1.5 top-0 w-3 h-3 rounded-full bg-blue-50 flex items-center justify-center text-blue-500" data-id="element-106">
                          <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-107">
                            <circle cx="12" cy="12" r="10" data-id="element-108" />
                            <polyline points="12 6 12 12 16 14" data-id="element-109" />
                          </svg>
                        </div>
                        <div className="text-[9px] font-bold text-slate-800 leading-tight" data-id="element-110">
                          Initial call — unreachable
                        </div>
                        <div className="text-[8px] text-slate-500" data-id="element-111">
                          → Trigger skip tracing
                        </div>
                        <div className="text-[7px] text-slate-400" data-id="element-112">
                          Feb 5 · 9:20 AM
                        </div>
                      </div>
                      <div className="relative pl-4" data-id="element-113">
                        <div className="absolute -left-1.5 top-0 w-3 h-3 rounded-full bg-purple-50 flex items-center justify-center text-purple-500" data-id="element-114">
                          <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-115">
                            <path d="M20 6 9 17l-5-5" data-id="element-116" />
                          </svg>
                        </div>
                        <div className="flex items-center gap-1" data-id="element-117">
                          <div className="text-[9px] font-bold text-slate-800 leading-tight" data-id="element-118">
                            Skip trace completed
                          </div>
                          <span className="bg-emerald-100 text-emerald-700 text-[6px] px-1 rounded font-bold" data-id="element-119">
                            Done
                          </span>
                        </div>
                        <div className="text-[8px] text-slate-500 leading-snug" data-id="element-120">
                          New verified number located
                        </div>
                        <div className="text-[7px] text-slate-400" data-id="element-121">
                          Feb 7 · 10:05 AM
                        </div>
                      </div>
                      <div className="relative pl-4" data-id="element-122">
                        <div className="absolute -left-1.5 top-0 w-3 h-3 rounded-full bg-amber-50 flex items-center justify-center text-amber-500" data-id="element-123">
                          <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-124">
                            <circle cx="12" cy="12" r="10" data-id="element-125" />
                            <polyline points="12 6 12 12 16 14" data-id="element-126" />
                          </svg>
                        </div>
                        <div className="text-[9px] font-bold text-slate-800 leading-tight" data-id="element-127">
                          AI call — wire confirmed
                        </div>
                        <span className="bg-amber-100 text-amber-700 text-[6px] px-1 rounded font-bold" data-id="element-128">
                          Awaiting run
                        </span>
                        <div className="text-[8px] text-slate-500 leading-snug" data-id="element-129">
                          Wire verified Gmail + portal
                        </div>
                        <div className="text-[7px] text-slate-400" data-id="element-130">
                          Feb 7 · 11:00 AM
                        </div>
                      </div>
                      <div className="relative pl-4" data-id="element-131">
                        <div className="absolute -left-1.5 top-0 w-3 h-3 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-500" data-id="element-132">
                          <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-133">
                            <path d="M20 6 9 17l-5-5" data-id="element-134" />
                          </svg>
                        </div>
                        <div className="text-[9px] font-bold text-slate-800 leading-tight" data-id="element-135">
                          Compliance check passed
                        </div>
                        <span className="bg-emerald-100 text-emerald-700 text-[6px] px-1 rounded font-bold" data-id="element-136">
                          FDCPA ✓
                        </span>
                        <div className="text-[8px] text-slate-500 leading-snug" data-id="element-137">
                          Logged, auditable, verified
                        </div>
                        <div className="text-[7px] text-slate-400" data-id="element-138">
                          Feb 7 · 11:01 AM
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VALUE PROPS */}
        <section className="px-10 py-5 grid grid-cols-3 gap-6 bg-[#F8F7F6]" data-id="element-139">
          <div data-id="element-140">
            <h3 className="mb-3 font-['Tiro_Gurmukhi',_serif] text-[16px] font-[900] text-[#000000]" data-id="element-141">
              Build any complex collection workflows in minutes.
            </h3>
            <p className="text-[13px] leading-relaxed font-['Tiro_Gurmukhi',_serif] font-[500] text-[#0C0C0CB1]" data-id="element-142">
              Configure complex, multi-step collections workflows on any system
              with our agent studio — just by prompting. Configure it by
              customer segment, optimal time and enable skip tracing to maximise
              response rates.
            </p>
          </div>
          <div data-id="element-143">
            <h3 className="font-bold mb-3 text-[16px] font-['Tiro_Gurmukhi',_serif] text-[#000000]" data-id="element-144">
              Zero engineering needed with sub 2 week integrations.
            </h3>
            <p className="text-[13px] leading-relaxed font-['Tiro_Gurmukhi',_serif] text-[#0C0C0CB1]" data-id="element-145">
              Our browser and computer vision agents can operate on any of your
              systems without any APIs, or technical engineering resources from
              your end. We typically can complete integrations 2 weeks.
            </p>
          </div>
          <div data-id="element-146">
            <h3 className="font-bold mb-3 text-[16px] font-['Tiro_Gurmukhi',_serif] text-[#000000]" data-id="element-147">
              Compliance at the heart of every agent action.
            </h3>
            <p className="text-[13px] leading-relaxed font-['Tiro_Gurmukhi',_serif] text-[#0C0C0CB1]" data-id="element-148">
              100+ jurisdiction guardrails enforced at the agent level. Every
              interaction is logged, auditable, and defensible.
            </p>
          </div>
        </section>

        {/* CASE STUDY */}
        <section className="px-10 py-5 flex-1 bg-[#F8F7F6]" data-id="element-149">
          <div className="text-[#0284C7] font-bold tracking-wider mb-3 uppercase text-base font-['Tiro_Gurmukhi',_serif]" data-id="element-150">
            Case study
          </div>

          <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm" data-id="element-151">
            <div className="px-5 py-3 border-b border-slate-100" data-id="element-152">
              <p className="text-[13px] leading-relaxed font-['Tiro_Gurmukhi',_serif] font-[900] text-[#1D293B]" data-id="element-153">
                We worked with a $5B fintech and built autonomous collection
                agents on their $500M loan book — replacing manual collector
                workflows, saving them $2M and recovering $30M more per annum.
              </p>
            </div>

            <div className="grid grid-cols-2 divide-x divide-slate-100" data-id="element-154">
              {/* Before */}
              <div className="p-5" data-id="element-155">
                <div className="flex items-center gap-2 mb-3" data-id="element-156">
                  <span className="text-red-500 text-[10px] font-bold tracking-wider uppercase font-['Open_Sans',_sans-serif]" data-id="element-157">
                    Before
                  </span>
                  <span className="bg-red-50 text-red-700 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-158">
                    Manual
                  </span>
                </div>
                <div className="mb-3" data-id="element-159">
                  <div className="text-2xl font-bold text-red-500 mb-0.5" data-id="element-160">
                    15%
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-161">
                    collection rates on delinquent accounts
                  </div>
                </div>
                <div className="mb-3" data-id="element-162">
                  <div className="text-xl font-bold text-red-500 mb-0.5" data-id="element-163">
                    High cost
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-164">
                    human collectors, inconsistent coverage
                  </div>
                </div>
                <div data-id="element-165">
                  <div className="text-xl font-bold text-red-500 mb-0.5" data-id="element-166">
                    Slow
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-167">
                    follow-up limited by team bandwidth
                  </div>
                </div>
              </div>

              {/* After */}
              <div className="p-5" data-id="element-168">
                <div className="flex items-center gap-2 mb-3" data-id="element-169">
                  <span className="text-emerald-600 text-[10px] font-bold tracking-wider uppercase" data-id="element-170">
                    After
                  </span>
                  <span className="bg-emerald-50 text-emerald-700 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-171">
                    Proximitty
                  </span>
                </div>
                <div className="mb-3" data-id="element-172">
                  <div className="text-2xl font-bold text-emerald-600 mb-0.5" data-id="element-173">
                    &gt;10% lift
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-174">
                    projected $30M annual improvement in recoveries
                  </div>
                </div>
                <div className="mb-3" data-id="element-175">
                  <div className="text-xl font-bold text-emerald-600 mb-0.5" data-id="element-176">
                    &gt;$2M
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-177">
                    in operational cost savings
                  </div>
                </div>
                <div data-id="element-178">
                  <div className="text-xl font-bold text-emerald-600 mb-0.5" data-id="element-179">
                    5×
                  </div>
                  <div className="text-[11px] text-[#1A2234]" data-id="element-180">
                    increase in borrower engagement
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="px-10 py-6 flex justify-between items-center mt-auto border-t border-slate-100 bg-[#F8F7F6]" data-id="element-181">
          <div data-id="element-182">
            <div className="font-semibold text-sm mb-1 text-[#0382C7]" data-id="element-183">
              Trusted by publicly traded fintechs and banks.
            </div>
            <div className="text-[#0284C7] text-xs font-medium" data-id="element-184">
              Request a pilot today →
            </div>
          </div>
          <div className="flex gap-10 text-right" data-id="element-185">
            <div data-id="element-186">
              <div className="font-bold text-sm text-slate-800" data-id="element-187">Wye Yew Ho</div>
              <div className="text-slate-500 text-xs" data-id="element-188">CEO</div>
              <div className="text-slate-500 text-xs mt-1" data-id="element-189">
                wyeyew@proximitty.ai
              </div>
              <div className="text-slate-500 text-xs" data-id="element-190">(929) 638 6764</div>
            </div>
            <div data-id="element-191">
              <div className="font-bold text-sm text-slate-800" data-id="element-192">
                Zixuan Zhang
              </div>
              <div className="text-slate-500 text-xs" data-id="element-193">CTO</div>
              <div className="text-slate-500 text-xs mt-1" data-id="element-194">
                zi@proximitty.ai
              </div>
              <div className="text-slate-500 text-xs" data-id="element-195">(651) 246 8938</div>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}